import '@/components/keenicons/assets/styles.css';
import './styles/globals.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { ProvidersWrapper } from './providers';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import { ensureBrowserRandomUUID } from '@/utils/createBrowserSafeId';
import { applyGoogleTranslateDomFix } from '@/utils/applyGoogleTranslateDomFix';

ensureBrowserRandomUUID();
applyGoogleTranslateDomFix();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ProvidersWrapper>
    <App />
  </ProvidersWrapper>
);
//<React.StrictMode>
//</React.StrictMode>
